import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * An enum containing all our current launch darkly
 * feature flags
 */
export enum FeatureFlag {
  AccessHistoricalPerDiem = 'accessHistoricalPerDiem',
  DisableBanners = 'disableBanners',
  DisplayReturnBookedAppointments = 'displayReturnBookedAppointments',
  DynamicBanner = 'dynamicBanner',
  Maintenance = 'maintenance',
  ShippersDashboard = 'shippersDashboard',
  ShippersWatchlist = 'shippersWatchlist',
  ShippersWatchlistHistoryTab = 'shippersWathlistHistoryTab',
  SmartPerDiem = 'smartPerDiem',
  SmartPerDiemApptScreenshots = 'smartPerDiemApptScreenshots',
  SmartPerDiemOverrides = 'smartPerDiemOverrides',
  AccessHistoricalErlTable = 'accessHistoricalErlTable',
  DisputeDemo = 'disputeDemo',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FeatureFlags = Partial<Record<FeatureFlag, any>>;

/**
 * Checks a record of flags for the specified flag and returns
 * its value with optional type casting (defaults to boolean)
 * @param flag the flag to request
 * @param flags the collection of flags
 * @returns the value of the requested flag
 */
export function getFeatureFlag<T = boolean>(flag: FeatureFlag, flags: FeatureFlags): T | undefined {
  return flags[flag];
}

/**
 * Returns the value of the specified feature flag
 * with optional type casting (defaults to boolean)
 * @param flag the flag to request
 * @returns the value of the flag
 */
export function useFeatureFlag<T = boolean>(flag: FeatureFlag): T | undefined {
  const flags = useFlags();
  return getFeatureFlag<T>(flag, flags);
}
